<template>
  <div class="container page">
    <van-nav-bar :title="$t('addBankCard')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{ $t('payCardInfoPlaceholder') }}</div>
      <van-cell-group>
        <van-field label-width="120" v-model="username" :label="$t('fullName')" :placeholder="$t('fullName')" />
        <van-field label-width="120" v-model="bankname" :label="$t('bankName')" :placeholder="$t('bankName')" />
        <!-- <van-field label-width="120" v-model="cardnum" :label="$t('bankCardNumber')" :placeholder="$t('bankCardNumber')" /> -->
      </van-cell-group>
      <p>{{ $t('addBankCardPrompt') }}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{ $t('addBankCard') }}</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      bankname: "",
      // cardnum: "",
    };
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    bindCard() {
      if (!this.username) {
        return this.$toast(this.$t('selectBank'));
      }
      if (!this.bankname) {
        return this.$toast(this.$t('selectBank'));
      }
      // if (!this.cardnum) {
      //   return this.$toast(this.$t('selectBank'));
      // }
      // if (this.$i18n.locale == 'de') {
      //   if (!(this.cardnum.startsWith("DE"))) {
      //     return this.$toast(this.$t('VerifyDECardNumber'));
      //   }
      // }
      this.$httpNew({
        method: 'post',
        data: {
          username: this.username,
          bankname: this.bankname,
          // cardnum: this.cardnum
        },
        url: 'set_bank_info'
      }).then(res => {
        if (res.code == 0) {
          this.$router.push({ path: '/Mine' })
          this.$toast(res.info);
        } else {
          this.$toast(res.info);
        }
      })
    },
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-cell {
  font-size: 32px;
  line-height: 80px;
}

.van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.bankbox {
  padding: 15px;
  color: #000;
  background-color: #fff;
}

.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.main-box {
  background: #fff;

}

.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #000;
}

::v-deep .van-picker__toolbar {
  height: 50px;
}

::v-deep .van-picker__cancel,
.van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}

::v-deep .van-picker-column {
  font-size: 40px;
}

.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}

.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #323233, #000000);
}
</style>
